import React from 'react'
import styles from './styles.module.scss'

const PaymentsHeader: React.FC = () => {
	return (
		<header className={styles.invoicesHeader}>
			<div className={styles.invoicesHeader_title}>
				<h3>Payments</h3>
			</div>
		</header>
	)
}

export default PaymentsHeader
